<script lang="ts" setup>
import { ref } from 'vue';
import EDocumentSaveScreen, { ISaveInfo } from '../../ChoiceScreens/EDocuments/EDocumentSaveScreen.vue';
import ChoiceButton from '../../components/Buttons/ChoiceButton.vue';
import { ActionButtonStyle } from '../../lib/Types/Types';
import Row from '../../components/Section/Row.vue';
import { MenuNameType } from '../../Enums/ChoiceEnums';

    const saveEDocsRef = ref<InstanceType<typeof EDocumentSaveScreen>>();
    const saveInfo = ref<ISaveInfo>();
    function onShowSaveData()
    {
        saveInfo.value = saveEDocsRef.value?.getSaveInfo();
    }


</script>

<template>
    <b>Choice Components:</b>

    <div class="mt-2">
        <EDocumentSaveScreen ref="saveEDocsRef" filename="theFileName">
            <template #DocumentInfo>
                Some doc info
            </template>
            <template #FileNameRight>
                Filename Addendum
            </template>
        </EDocumentSaveScreen>

        <Row :topPadding="2">
            <div v-if="saveInfo">
                SaveInfo: {{ saveInfo }}
            </div>
            <ChoiceButton :action="ActionButtonStyle.Save" @click="onShowSaveData" >Show Save Data</ChoiceButton>
        </Row>
    </div>
</template>